import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { Tooltip } from "@/Components/v2/atoms/ToolTip/Tooltip";

const SatCurveLink = ({ onClick }: { onClick: () => void }) => (
  <Tooltip title="View curve" placement="top">
    <ArrowForwardIcon onClick={onClick} style={{ cursor: "pointer" }} />
  </Tooltip>
);

export default SatCurveLink;
